import { useState } from "react";
import { faqs } from "@/mocks/guaData";

export default function Faq() {
  const [openId, setOpenId] = useState<string | null>(faqs[0].id);

  return (
    <section id="faq" className="bg-background-100 py-14 md:py-20">
      <div className="container-page">
        <div className="mx-auto max-w-3xl">
          <div className="mb-8 text-center">
            <h2 className="heading-font text-2xl text-foreground-950 md:text-3xl">
              吃瓜小问 🤔
            </h2>
            <p className="mt-3 text-sm text-foreground-500">
              关于本站，你可能想知道的一切都在这里
            </p>
          </div>

          <div className="space-y-3">
            {faqs.map((f) => {
              const open = openId === f.id;
              return (
                <div
                  key={f.id}
                  className={`overflow-hidden rounded-2xl bg-background-50 transition-shadow ${
                    open ? "shadow-md" : ""
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpenId(open ? null : f.id)}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
                  >
                    <h3 className="text-sm font-bold text-foreground-900 md:text-base">
                      {f.q}
                    </h3>
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-700 transition-transform ${
                        open ? "rotate-45" : ""
                      }`}
                    >
                      <i className="ri-add-line"></i>
                    </span>
                  </button>
                  {open && (
                    <p className="px-5 pb-5 text-sm leading-7 text-foreground-600 md:px-6">
                      {f.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}